import { GlobalState } from '../../actions';

const portalSelector = (state: GlobalState) => state.portal;

export const portalRootHighscoresSelector = (state: GlobalState) => portalSelector(state).rootHighscores;
export const portalLastHighscoresSelector = (state: GlobalState) => portalSelector(state).lastHighscores;
export const portalRootRoundSelector = (state: GlobalState) => portalSelector(state).rootRound;
export const portalLastRoundSelector = (state: GlobalState) => portalSelector(state).lastRound;
export const portalRootUserHighscoreSelector = (state: GlobalState) => portalSelector(state).rootUserHighscore;
export const portalLastUserHighscoreSelector = (state: GlobalState) => portalSelector(state).lastUserHighscore;